/** Lazy loaders — só o gateway selecionado é baixado e montado. */
export const GATEWAY_LOADERS = {
  'card-stripe': () => import('../components/gateways/CreditCardStripe.vue'),
  card: () => import('../components/gateways/CreditCardPayPal.vue'),
  'paypal-order': () => import('../components/gateways/PayPal.vue'),
  'stripe-subscription': () => import('../components/gateways/StripeSubscription.vue'),
  'card-pagarme': () => import('../components/gateways/Pagarme'),
  'pagarme-subscription': () => import('../components/gateways/Pagarme'),
  'card-pagseguro': () => import('../components/gateways/PagSeguro'),
  'pagseguro-subscription': () => import('../components/gateways/PagSeguro'),
  'card-mercadopago': () => import('../components/gateways/MercadoPago'),
  'mercadopago-subscription': () => import('../components/gateways/MercadoPago'),
  'card-iugu': () => import('../components/gateways/CreditCardIugu'),
  'iugu-subscription': () => import('../components/gateways/CreditCardIugu'),
  'card-galaxpay': () => import('../components/gateways/CreditCardGalaxPay'),
  'galaxpay-subscription': () => import('../components/gateways/CreditCardGalaxPay'),
  'paypal-subscription': () => import('../components/gateways/PayPalSubscription.vue'),
  boleto: () => import('../components/gateways/Ticket.vue'),
  transferencia: () => import('../components/gateways/BankTransfer.vue'),
  pix: () => import('../components/gateways/Pix.vue'),
  picpay: () => import('../components/gateways/PicPay.vue')
};

export function getGatewayLoader(paymentMethod) {
  if (!paymentMethod) {
    return null;
  }
  return GATEWAY_LOADERS[paymentMethod] || null;
}
